import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=1de2c5b1&scoped=true&"
import script from "./Parents.vue?vue&type=script&lang=js&"
export * from "./Parents.vue?vue&type=script&lang=js&"
import style0 from "./Parents.vue?vue&type=style&index=0&id=1de2c5b1&prod&lang=scss&scoped=true&"
import style1 from "./Parents.vue?vue&type=style&index=1&id=1de2c5b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de2c5b1",
  null
  
)

export default component.exports